import React from 'react';
import { Dropdown } from 'antd';
import { Check, Palette } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/context/ThemeContext';

/** 테마 색 미리보기 — 껍데기 / 강조 / 본문 세 칸 */
const Swatch = ({ colors }) => (
  <span className="flex shrink-0 overflow-hidden rounded border border-black/10">
    {colors.map((color) => (
      <span key={color} className="h-4 w-3" style={{ background: color }} />
    ))}
  </span>
);

/**
 * 테마 선택기 (상단바).
 *
 * 목록 자체는 antd Dropdown 이라 선택한 테마의 antd 토큰을 그대로 따른다.
 */
const ThemeSwitcher = ({ variant = 'chrome' }) => {
  const { theme, setTheme, themes } = useTheme();

  const items = themes.map((option) => ({
    key: option.value,
    label: (
      <span className="flex items-center gap-2.5 py-0.5">
        <Swatch colors={option.swatch} />
        <span className="min-w-0">
          <span className="block text-sm font-semibold">{option.label}</span>
          <span className="block text-[11px] opacity-60">{option.description}</span>
        </span>
        {theme === option.value && <Check size={15} className="ml-auto shrink-0 text-[var(--brand)]" />}
      </span>
    ),
  }));

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      menu={{ items, onClick: ({ key }) => setTheme(key), selectedKeys: [theme] }}
    >
      <button
        type="button"
        aria-label="테마 선택"
        title="테마 선택"
        className={cn(
          'flex items-center gap-1.5 rounded-md p-1.5 transition-colors',
          variant === 'chrome'
            ? 'text-[var(--chrome-muted)] hover:bg-[var(--chrome-hover)] hover:text-[var(--chrome-text-strong)]'
            : 'text-[var(--text-muted)] hover:bg-[var(--surface-hover)] hover:text-[var(--text)]'
        )}
      >
        <Palette size={18} />
      </button>
    </Dropdown>
  );
};

export default ThemeSwitcher;
